export const CANTIDAD_MINUTOS_POR_HORA_CATEDRA = 40;
export const COOKIES_NAME = "mi-escuela";
export const DEFAULT_LIMIT_PAGINATION = 10;
